export default __webpack_public_path__ + "7bf416fac0b5b23ab412eda8f33961fb.png";